import { useEffect, useState } from "preact/hooks";

export function useIsPWAStandalone() {
  const mediaQueryList = window.matchMedia("(display-mode: standalone)");
  const [isStandalone, setIsStandalone] = useState(mediaQueryList.matches);
  useEffect(() => {
    const handleChange = (event) => {
      setIsStandalone(event.matches);
    };
    mediaQueryList.addEventListener('change', handleChange);
    return () => {
      mediaQueryList.removeEventListener('change', handleChange);
    };
  }, []);
  return isStandalone;
}
